import { dropdownValueApi } from "@/api/dropdownValueApi";

export default {
  actions: {
    async create({ dispatch }, data) {
      await dropdownValueApi.create(data);
      await dispatch("listWithReleaseNotes", data.dropdownId);
    },

    async listWithReleaseNotes({ commit }, dropdownId) {
      const response = await dropdownValueApi.listWithReleaseNotes(dropdownId);
      commit("setListWithReleaseNotes", response.data.result);
    },

    async list({ commit }, dropdownId) {
      const response = await dropdownValueApi.list(dropdownId);
      commit("setList", response.data.result);
    },

    async remove({ dispatch }, data) {
      await dropdownValueApi.remove(data);
      await dispatch("listWithReleaseNotes", data.dropdownId);
      return true;
    },

    async update({ commit, dispatch, state }, data) {
      const record = await dropdownValueApi.update(data);
      commit("setRecord", record);
      await dispatch("listWithReleaseNotes", data.dropdownId);
      return state.record;
    },
  },
  getters: {
    getById: state => findId => {
      return state.list.find(item => {
        return item.id === findId;
      });
    },
  },
  mutations: {
    setRecord(state, dropdownValue) {
      state.record = dropdownValue;
    },
    setList(state, list) {
      state.list = list;
    },
    setListWithReleaseNotes(state, list) {
      state.listWithReleaseNotes = list;
    },
  },
  namespaced: true,
  state: {
    list: [],
    listWithReleaseNotes: [],
    record: {},
  },
};
